import { COLORS } from "@/app/common/consts/colors";
import type { IconProps } from "./type";

export default function EmptyBox({ color = "lightblack" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="161"
      height="161"
      viewBox="0 0 161 161"
      fill="none"
    >
      <g opacity="0.3">
        <path
          d="M80.5 123.957C56.1321 123.957 36.6431 104.468 36.6431 80.1C36.6431 55.7321 56.1321 36.243 80.5 36.243V0.5C36.2343 0.5 0.5 36.2343 0.5 80.5C0.5 124.766 36.2343 160.5 80.5 160.5C124.766 160.5 160.5 124.766 160.5 80.5H124.766C124.357 104.459 104.868 123.957 80.5 123.957Z"
          fill="#14141E"
        />
        <path
          d="M124.357 36.2357H80.5V80.0927H124.357V36.2357Z"
          fill="#888888"
        />
      </g>
    </svg>
  );
}
